// Shared popup UI for mention and slash command menus.
// Creates a floating div with keyboard-navigable items.

export function createSuggestionPopup() {
  let popup = null
  let items = []
  let selectedIndex = 0
  let onSelect = null

  function render() {
    if (!popup) return
    popup.innerHTML = ""

    items.forEach((item, index) => {
      const el = document.createElement("button")
      el.type = "button"
      el.className = `suggestion-item ${index === selectedIndex ? "is-selected" : ""}`
      el.textContent = item.label || item.name || item.title
      el.addEventListener("mouseenter", () => {
        selectedIndex = index
        render()
      })
      el.addEventListener("click", () => {
        onSelect?.(item)
      })
      popup.appendChild(el)
    })
  }

  return {
    onStart(props) {
      popup = document.createElement("div")
      popup.className = "suggestion-popup"
      document.body.appendChild(popup)

      items = props.items || []
      selectedIndex = 0
      onSelect = (item) => props.command(item)

      render()
      this._updatePosition(props)
    },

    onUpdate(props) {
      items = props.items || []
      selectedIndex = 0
      onSelect = (item) => props.command(item)

      render()
      this._updatePosition(props)
    },

    onKeyDown(props) {
      const { event } = props

      if (event.key === "ArrowUp") {
        selectedIndex = (selectedIndex - 1 + items.length) % items.length
        render()
        return true
      }

      if (event.key === "ArrowDown") {
        selectedIndex = (selectedIndex + 1) % items.length
        render()
        return true
      }

      if (event.key === "Enter") {
        if (items[selectedIndex]) {
          onSelect?.(items[selectedIndex])
        }
        return true
      }

      if (event.key === "Escape") {
        this.onExit()
        return true
      }

      return false
    },

    onExit() {
      if (popup) {
        popup.remove()
        popup = null
      }
    },

    _updatePosition(props) {
      if (!popup || !props.clientRect) return
      const rect = props.clientRect()
      if (!rect) return

      popup.style.position = "fixed"
      popup.style.left = `${rect.left}px`
      popup.style.top = `${rect.bottom + 4}px`
      popup.style.zIndex = "50"
    },
  }
}
